import React, { useState } from "react";
import { Board, Dice, RollButton, Question } from "../../components";
import { Button } from "../../../login/components";
import styles from "./index.module.scss";
import dur from "../../../../static/images/shakuni-blck.jpeg";
import kar from "../../../../static/images/draupadi-blck.jpeg";
import sha from "../../../../static/images/gandhari.jpeg";
import yud from "../../../../static/images/yudh-blck.jpeg";
import { useParams } from "react-router-dom";

const sides = [1, 4, 6, 3];

function Game() {
  const [state, setState] = useState({
    diceNumber1: 0,
    diceNumber2: 0,
    showInfo: false,
    showQuestion: false,
  });
  const [selected, setSelected] = useState({
    pos1: 0,
    pos2: 34,
    pos3: 51,
    pos4: 17,
  });

  const { pos1, pos2, pos3, pos4 } = selected;

  const [streak, setStreak] = useState(0);
  // const [annimate, setAnnimate] = useState(false);

  const parama: {
    id?: String;
    name?: String;
  } = useParams();

  const { diceNumber1, diceNumber2, showInfo, showQuestion } = state;

  const roll = () => {
    setState({ ...state, showQuestion: !showQuestion });
    // const diceNumber1 = sides[Math.floor(Math.random() * sides.length)];
    // const diceNumber2 = sides[Math.floor(Math.random() * sides.length)];
    // setState({ ...state, diceNumber1, diceNumber2 });
    // setAnnimate(true);
  };

  const changeStreak = (strk: any) => {
    setStreak(strk);
    // increase(streak);
  };

  const increase = (inc: number) => {
    console.log("INC");
    // if (pos1 + inc > 5) {
    //   alert("Bonue");
    // }
    if (pos1 + inc > 67) {
      setSelected({ ...selected, pos1: 0 });
      alert("Game Over");
    } else {
      setSelected({ ...selected, pos1: pos1 + inc });
      setStreak(0);
    }
    setState({ ...state, diceNumber1: 0, diceNumber2: 0 });
  };

  return (
    <div className={styles.bg}>
      <div className={styles.bckg}>
        {/* <h1>Game</h1> */}
        {showQuestion && (
          <Question
            close={() => {
              setState({ ...state, showQuestion: false });
            }}
            changeStreak={changeStreak}
          />
        )}
        <div className={styles.levels}>
          <p>Level: Vishwaroopa Darshana</p>
        </div>
        <div className={styles.streak}>
          <p>Streak: {streak}</p>
        </div>
        <div className={`${styles.yudImg} ${styles.playerImg}`}>
          <img src={yud} alt="" />
          Player 1: Yudhisthira ({parama.name})
        </div>
        <div className={`${styles.durImg} ${styles.playerImg}`}>
          <img src={dur} alt="" />
          Player 2: Shakuni ( AI )
        </div>
        <div className={`${styles.shaImg} ${styles.playerImg}`}>
          <img src={sha} alt="" />
          Player 4: Gandhari ( AI )
        </div>
        <div className={`${styles.karImg} ${styles.playerImg}`}>
          <img src={kar} alt="" />
          Player 3: Draupadi ( AI )
        </div>
        <h2 className={styles.score1}>Score: {selected.pos1}</h2>
        <h2 className={styles.score2}>Score: {0}</h2>
        <h2 className={styles.score3}>Score: {0}</h2>
        <h2 className={styles.score4}>Score: {0}</h2>
        {showInfo && (
          <div
            onClick={() => setState({ ...state, showInfo: false })}
            className={styles.trivia}
          >
            <h1>Information About Yudhishtira</h1>
            <h2>Also Known as: Dharmaraja</h2>
            <p>
              Yudhisthira was the eldest son of King Pandu and Queen Kunti, king
              of Hastinapura and Indraprastha, and World Emperor. The eldest of
              the pancha Pandavas, he was born to Kunti when she invoked the
              Yama, the God of Dharma and death. Hence he was born with the
              attributes of the lord and was an ardent follower of Dharma.
              <br />
              <br />
              Yuddha means war and sthira means steady in Sanskrit. Yudhishthira
              means one who is steady in war.
              <br />
              <br />
            </p>
            <h3>Some Lesser Know Facts: </h3>
            <p className={styles.left}>
              Yudhishthira was 2nd tallest Pandava (after Bhimasena).
              <br />
              Yudhishthira had killed so many rakshas.
              <br />
              Yudhishthira’s was taught by Parashurama, Shiva, etc.
              <br />
              As per Puranas, he had already three wives Nari, Draupadi and
              Devika.
              <br />
              Yudhishthira loved Bhima most, Respecting Draupadi most,
              worshipping his mother most, and was followers of his elders.
              <br />
              Yudhishthira was Ajatashatru and had no enemy.
              <br />
              Yudhishthira went Heaven in his mortal body.
            </p>
            <span>
              More Info{" "}
              <a
                href="https://mahabharata.fandom.com/wiki/Yudhisthira"
                target="_blank"
                rel="noreferrer"
              >
                Here
              </a>
            </span>
          </div>
        )}
        {/* <Dice
        top={true}
        rolled={diceNumber1}
        // increase={increase}
        isAnnimate={annimate}
        stopAnnimation={() => setAnnimate(false)}
      />
      <Dice
        rolled={diceNumber2}
        // increase={increase}
        isAnnimate={annimate}
        stopAnnimation={() => setAnnimate(false)}
      /> */}
        <Board
          selected={pos1}
          userData={parama}
          pos1={pos1}
          pos2={pos2}
          pos3={pos3}
          pos4={pos4}
          changeStreak={changeStreak}
        />
        <RollButton roll={roll} />
        <h2 className={styles.youAre}>
          You are : Yudhishtira ({parama.name})
          <Button
            type="secondary"
            name="Get Info About Your Character"
            onClick={() => setState({ ...state, showInfo: true })}
          />
        </h2>
        <Button name="Play" onClick={() => increase(streak)} />
      </div>
    </div>
  );
}

export default Game;
